import React, { ReactNode, useContext, useEffect, useState } from "react";
import LyricsModalContext from "./LyricsModalContext";
import callApi from "../../components/call-api/call-api";
import { getLyrics } from "../../components/apis/music-api";
import { LyricsResponse } from "../../types/LyricsResponse";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import { format } from "../../components/text-helper/text-helper";

interface LyricsModalProviderProps {
    children: ReactNode;
}

const LyricsModalProvider = (props: LyricsModalProviderProps) => {
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ lyricsModalOpen, setLyricsModalOpen ] = useState<boolean>(false);
    const [ artist, setArtist ] = useState<string | undefined>(undefined);
    const [ track, setTrack ] = useState<string | undefined>(undefined);
    const [ lyrics, setLyrics ] = useState<string | undefined>(undefined);
    const [ loading, setLoading ] = useState<boolean>(false);
    const [ errorOccured, setErrorOccurred ] = useState<boolean>(false);

    const setLyricsResponse = (response: LyricsResponse | undefined) => {
        setLyrics(response?.lyrics);
    };

    useEffect(() => {
        if (lyricsModalOpen) {
            setLyrics(undefined);
            setErrorOccurred(false);
            const artistFormatted = format(artist ?? '');
            callApi(getLyrics(getAccessToken(), artistFormatted, track ?? ''), setLyricsResponse, setLoading)
        }
    }, [lyricsModalOpen]);

    useEffect(() => {
        if (!loading && !lyrics) {
            setErrorOccurred(true);
        } else {
            setErrorOccurred(false);
        }
    }, [loading, lyricsModalOpen]);

    return (
        <LyricsModalContext.Provider value={{
            lyricsModalOpen,
            setLyricsModalOpen,
            setArtist,
            setTrack,
            setLyrics,
            artist,
            track,
            lyrics,
            loading,
            setLoading,
            errorOccurred: errorOccured,
            setErrorOccurred,
        }}>
            {props.children}
        </LyricsModalContext.Provider>
    );
}

export default LyricsModalProvider;
